import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bstoggle',
	templateUrl:'./BSTogglePluginCompPage.html',
	styles: [],
	styleUrls:['./BSTogglePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSTogglePluginCompPage
{
	mdContent_877 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.toggle.BSToggle;
\`\`\``;
	mdContent_878 = `\`\`\`java
BSToggle()
\`\`\``;
	mdContent_879 = `\`\`\`java
BSToggle&lt;?&gt; toggle = new BSToggle&lt;&gt;();
toggle.setLabel("Dark mode");
toggle.setChecked(false);
\`\`\``;
}
